import { useAuth } from '../context/AuthContext';
export function usePermission(role) {
    const { user } = useAuth();
    if (!user) return false;
    if (role === 'admin') return user.role === 'admin';
    return ['admin', 'funcionario'].includes(user.role);
}
